import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test220625 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 22/06/2025 Candidates</h3>
      <br />
      <br />


        <div><Link to='/conduct-ronbanchoba'>1. AAT  7645  MR.RONBANCHOB APIRATIKUL---Trying for JO SYOKYU</Link></div>
        <br />
        <div><Link to='/conduct-surachett'>2. AAT  7541  MR.SURACHET THAREEPHUT(1KYU)---Trying for SHODAN-HO</Link></div>
        <br />
        <div><Link to='/conduct-santis'>3. AAT  7518  MR.SANTI SIRISAK(4KYU)---Trying for 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-jacquesp'>4. AAT  7369  MR.JACQUES DU PLESSIS(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-wannatouchp'>5. AAT  7847  MR.WANNATOUCH PRASERT(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-napasanunv'>6. AAT  7951  MS.NAPASANUN VONGVIVAT(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-issariyapar'>7. AAT  7952  MS.ISSARIYAPA ROOPSUWANNAKUL(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-manussaporne'>8. AAT  7942  MS.MANUSSAPORN  EKVISIT(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-karnts'>9. AAT  8007  MR.KARNT SRISUWAN(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pakawadn'>10. AAT  8008  MR.PAKAWAD NANTAJURAPLO(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-archirawishp'>11. AAT  8009  MR.ARCHIRAWISH PAKCHOTIPONG(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-praewpuns'>12. AAT  8010  PO.PRAEWPUN SUWANNAKOT(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-riradav'>13. AAT  8011  PO.RIRADA VANITWORACHOT(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-suphodh'>14. AAT  8012  CPO.SUPHOD HARASAN(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-kittipatw'>15. AAT  8013  MR.KITTIPAT  WIRIYA(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-orawanp'>16. AAT  8014  MS.ORAWAN PONGPRUEKSAPATTANA(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-sirawichu'>17. AAT  8015  MR.SIRAWICH  UDOMKANA(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pats'>18. AAT  8016  MR.PAT SUTHAPUNNAKUL(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />







        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test220625;
